/*
  Lily & June tab reminder (operator 27-10-2026, as Sableau): when the shopper leaves the tab with pieces in the cart,
  the tab title becomes "Don't forget this..." and the icon blinks with a red count. Back on the tab, all returns.
  Copy of the inline script on sableau.com.
*/
(function () {
  var link = document.querySelector('link[rel="icon"]');
  if (!link) { link = document.createElement('link'); link.rel = 'icon'; document.head.appendChild(link); }
  var orig = link.href, title = document.title, timer = null, badge = null, n = 0;
  function draw(img) {
    var c = document.createElement('canvas'); c.width = c.height = 64; var x = c.getContext('2d');
    if (img) x.drawImage(img, 0, 0, 64, 64);
    x.fillStyle = '#e0262b'; x.beginPath(); x.arc(42, 22, 22, 0, 7); x.fill();
    x.fillStyle = '#fff'; x.font = 'bold 30px Arial, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle'; x.fillText(n > 9 ? '9+' : String(n), 42, 24);
    try { return c.toDataURL('image/png'); } catch (e) { return null; } // tainted canvas (no CORS on the icon): redraw without it
  }
  function build(cb) {
    if (!orig) return cb(draw(null));
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () { cb(draw(img) || draw(null)); }; img.onerror = function () { cb(draw(null)); }; img.src = orig;
  }
  function start() {
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      // the shipping protection line is not a piece (assets/lj-protect.js)
      var pieces = c.items.filter(function (i) { return i.product_type !== 'Order Upsell'; }).reduce(function (s, i) { return s + i.quantity; }, 0);
      if (!document.hidden || !pieces) return;
      n = pieces; title = document.title;
      build(function (url) {
        if (!document.hidden) return;
        badge = url; document.title = window.LJ_I18N.tab_reminder;
        var on = false; timer = setInterval(function () { on = !on; link.href = on ? badge : orig; }, 1000);
        link.href = badge;
      });
    }).catch(function () {});
  }
  function stop() { if (timer) clearInterval(timer); timer = null; if (badge) { link.href = orig; document.title = title; badge = null; } }
  document.addEventListener('visibilitychange', function () { document.hidden ? start() : stop(); });
})();
